module.exports = __webpack_public_path__ + "img/visual_logo.9191afd5.png";